import styled from 'styled-components'
import { SPACING, TYPOGRAPHY, FONT_WEIGHT } from '../../../styles/theme'

export const PreferencesContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.md};
`

export const HelperText = styled.p`
  margin: 0;
  color: var(--color-text-tertiary);
  font-size: ${TYPOGRAPHY.caption.fontSize};
  line-height: 1.4;
`

export const ThemeOption = styled.div`
  max-width: 280px;
`

export const ThemeLabel = styled.label`
  font-size: ${TYPOGRAPHY.caption.fontSize};
  font-weight: ${FONT_WEIGHT.medium};
  color: var(--color-text-primary);
  margin-bottom: ${SPACING.xs};
  display: block;
`
